export function canonicalGithubRepo(raw: string): string {
  const value = raw.trim().replace(/^git@github\.com:/i, 'https://github.com/')
  const url = new URL(value.includes('://') ? value : `https://github.com/${value}`)
  if (!['https:', 'http:'].includes(url.protocol) || !/^(www\.)?github\.com$/i.test(url.hostname) || url.port || url.username || url.password || url.search || url.hash) {
    throw new Error('A GitHub repository URL is required')
  }
  const path = url.pathname.replace(/\/+$/, '').replace(/\.git$/i, '')
  if (!/^\/[a-z0-9_.-]+\/[a-z0-9_.-]+$/i.test(path)) throw new Error('A GitHub owner/repository is required')
  return path.slice(1).toLowerCase()
}

/** The canonical repository a stored URL names, or null when it names none. */
export function githubRepoKey(raw: unknown): string | null {
  if (typeof raw !== 'string') return null
  try { return canonicalGithubRepo(raw) } catch { return null }
}
